import { atomWithHash } from '@heidi/utils/jotai-helpers';

export const teamMemberLoginMethodAtom = atomWithHash<
  | 'LoggedWithSameAccount'
  | 'LoggedWithDifferentAccount'
  | 'SignIn'
  | 'SignUp'
  | 'Welcome'
  | 'InvalidLink'
  | undefined
>('teamMemberLoginMethod', 'Welcome', {
  setHash: 'replaceState',
});

export const userSignedUpViaInvite = atomWithHash<boolean>(
  'userSignedUpViaInvite',
  false,
  {
    setHash: 'replaceState',
  }
);
